import React, { useEffect, useState } from "react";
import { Button, Card, Col, Form, Input, Row, Spin, Switch, message } from "antd";
import { getInstructionsMethod, upsertInstructionsMethod } from "./api";
import { InstructionsPaymentConfig } from "./types";

const { TextArea } = Input;

interface Props {
  sellerCode: string;
  code: 'purchase-order' | 'bank-transfer' | 'check-money';
  cardTitle: string;
  helpText?: string;
}

export const InstructionsPaymentCard: React.FC<Props> = ({
  sellerCode,
  code,
  cardTitle,
  helpText,
}) => {
  const [form] = Form.useForm<InstructionsPaymentConfig>();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const data = await getInstructionsMethod(sellerCode, code);
      form.setFieldsValue(data);
    } catch (err: any) {
      message.error(`No se pudo cargar ${cardTitle}`);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (sellerCode) load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sellerCode, code]);

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      setSaving(true);
      await upsertInstructionsMethod(sellerCode, code, values);
      message.success(`${cardTitle} guardado`);
    } catch (err: any) {
      const msg = err?.response?.data?.message || err?.message || "Error al guardar";
      message.error(Array.isArray(msg) ? msg.join(" • ") : msg);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card
      title={cardTitle}
      extra={
        <Button type="primary" loading={saving} onClick={handleSave}>
          Guardar
        </Button>
      }
      style={{ marginBottom: 16 }}
    >
      <Spin spinning={loading}>
        <Form form={form} layout="vertical">
          <Row gutter={16}>
            <Col span={6}>
              <Form.Item label="Habilitado" name="enabled" valuePropName="checked">
                <Switch />
              </Form.Item>
            </Col>
            <Col span={9}>
              <Form.Item label="Título (opcional)" name="title">
                <Input />
              </Form.Item>
            </Col>
            <Col span={9}>
              <Form.Item label="Descripción (opcional)" name="description">
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item
            label={`Instrucciones para el cliente${helpText ? ` (${helpText})` : ''}`}
            name="instructions"
          >
            <TextArea rows={4} placeholder="Texto que verá el cliente al elegir este método de pago" />
          </Form.Item>
        </Form>
      </Spin>
    </Card>
  );
};
